const keySignatures = {
  C: ['C', 'D', 'E', 'F', 'G', 'A', 'B'],
  G: ['G', 'A', 'B', 'C', 'D', 'E', 'F#'],
  D: ['D', 'E', 'F#', 'G', 'A', 'B', 'C#'],
  A: ['A', 'B', 'C#', 'D', 'E', 'F#', 'G#'],
  E: ['E', 'F#', 'G#', 'A', 'B', 'C#', 'D#'],
  B: ['B', 'C#', 'D#', 'E', 'F#', 'G#', 'A#'],
  'F#': ['F#', 'G#', 'A#', 'B', 'C#', 'D#', 'E#'],
  'C#': ['C#', 'D#', 'E#', 'F#', 'G#', 'A#', 'B#'],
  Gb: ['Gb', 'Ab', 'Bb', 'Cb', 'Db', 'Eb', 'F'],
  Db: ['Db', 'Eb', 'F', 'Gb', 'Ab', 'Bb', 'C'],
  Ab: ['Ab', 'Bb', 'C', 'Db', 'Eb', 'F', 'G'],
  Eb: ['Eb', 'F', 'G', 'Ab', 'Bb', 'C', 'D'],
  Bb: ['Bb', 'C', 'D', 'Eb', 'F', 'G', 'A'],
  F: ['F', 'G', 'A', 'Bb', 'C', 'D', 'E'],

  Am: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
  Em: ['E', 'F#', 'G', 'A', 'B', 'C', 'D'],
  Bm: ['B', 'C#', 'D', 'E', 'F#', 'G', 'A'],
  'F#m': ['F#', 'G#', 'A', 'B', 'C#', 'D', 'E'],
  'C#m': ['C#', 'D#', 'E', 'F#', 'G#', 'A', 'B'],
  'G#m': ['G#', 'A#', 'B', 'C#', 'D#', 'E', 'F#'],
  'D#m': ['D#', 'E#', 'F#', 'G#', 'A#', 'B', 'C#'],
  Ebm: ['Eb', 'F', 'Gb', 'Ab', 'Bb', 'Cb', 'Db'],
  Bbm: ['Bb', 'C', 'Db', 'Eb', 'F', 'Gb', 'Ab'],
  Fm: ['F', 'G', 'Ab', 'Bb', 'C', 'Db', 'Eb'],
  Cm: ['C', 'D', 'Eb', 'F', 'G', 'Ab', 'Bb'],
  Gm: ['G', 'A', 'Bb', 'C', 'D', 'Eb', 'F'],
  Dm: ['D', 'E', 'F', 'G', 'A', 'Bb', 'C'],
};

export { keySignatures };
